import { Box, Stack, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { layoutGap } from '../../../../theme/theme';
import { OperationProgressPlaceholder } from '../../../../shared/ui/progress';
import {
  getWorkflowWorkspacePalette,
  getWorkspaceSubpageHeaderSurfaceSx,
  WorkspaceStatusPill,
} from '../../../../shared/ui/workflow/WorkflowWorkspacePrimitives';
import { CardTitle } from '../../../../shared/ui/typography';
import { VALIDATION_REPAIR_COPY } from '../../lib/validationRepairCopy';

/**
 * Full-workspace loading page shown while the lazy repair detail bundle loads.
 * Mirrors the ValidationRepairDetailPage shell (sticky subpage header + flex
 * body) so swapping in the real workspace does not shift the layout.
 */
export default function RepairWorkspaceLoadingFallback() {
  const theme = useTheme();
  const workspacePalette = getWorkflowWorkspacePalette(theme);
  const copy = VALIDATION_REPAIR_COPY.page;

  return (
    <Box
      data-testid="validation-repair-workspace-loading"
      sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}
    >
      <Box sx={getWorkspaceSubpageHeaderSurfaceSx(workspacePalette, { density: 'compact' })}>
        <Stack
          direction="row"
          spacing={layoutGap.steady}
          alignItems="center"
          sx={{ minHeight: 28, py: 0.1 }}
        >
          <CardTitle sx={{ color: workspacePalette.headingText }}>
            {copy.repairWorkspaceTitle}
          </CardTitle>
          <WorkspaceStatusPill label={copy.loadingRepairWorkspacePhase} tone="accent" />
        </Stack>
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          borderTop: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        }}
      >
        <OperationProgressPlaceholder
          model={{
            title: copy.loadingRepairWorkspaceTitle,
            message: copy.loadingRepairWorkspaceMessage,
            detail: copy.loadingRepairWorkspaceDetail,
            status: 'running',
            percent: null,
            phase: copy.loadingRepairWorkspacePhase,
            locked: true,
            steps: [
              { id: 'family', label: copy.loadingRepairWorkspaceSteps[0], status: 'current' },
              { id: 'points', label: copy.loadingRepairWorkspaceSteps[1], status: 'pending' },
              { id: 'actions', label: copy.loadingRepairWorkspaceSteps[2], status: 'pending' },
            ],
          }}
        />
      </Box>
    </Box>
  );
}
